import { PageRef } from 'providers/page-ref';

export type TestingRootPageParams = {};

export const ITestingRootPage: PageRef<TestingRootPageParams, void> = {
  pageName: 'TestingRootPage',
} as PageRef<TestingRootPageParams, void>;
